let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("arbaB")).then(() => parcelRequire('l7HbE'));